import { useSuspenseQuery } from "@apollo/client/react"
import { Settings } from "luxon"
import React, { useMemo, createContext, useContext } from "react"

import { GetVenueDocument, type GetVenueQuery, type GetVenueQueryVariables } from "@/graphql/graphql"
import NotFound from "@/pages/not_found"

// TODO: this should probably have a different name (?)

type VenueContextType = GetVenueQuery & {
  refetch: (variables?: Partial<GetVenueQueryVariables>) => Promise<any>
}

export const VenueContext = createContext<VenueContextType | null>(null)

export const useVenue = (): VenueContextType => {
  const context = useContext(VenueContext)
  if (!context) {
    throw new Error("useVenue must be used within a VenueProvider")
  }
  return context
}

export const VenueProvider: React.FC<{
  slug: string | null
  children: React.ReactNode
}> = ({ slug, children }) => {
  const { data, error, refetch } = useSuspenseQuery<GetVenueQuery, GetVenueQueryVariables>(GetVenueDocument, {
    variables: { slug, includeDeleted: true } as GetVenueQueryVariables,
  })

  const venue = useMemo(() => {
    const venue = data?.venue
    // Not-so-nice hack but useSuspenseQuery does not support onCompleted callback
    if (venue) {
      Settings.defaultZone = venue.timezone
    }
    return data?.venue
  }, [data])

  if (error) {
    throw error instanceof Error ? error : new Error("Venue context error")
  }

  if (!venue) {
    return <NotFound />
  }

  const contextValue = { ...data, refetch }

  return <VenueContext.Provider value={contextValue}>{children}</VenueContext.Provider>
}
